import React from 'react';
import { Button } from '@/components/ui/button';

export const SessionStatus = ({ error, onRetry }) => (
  <div className="min-h-screen flex flex-col gap-4 items-center justify-center bg-gray-50 p-6" data-testid="session-status">
    {error ? <>
      <p role="alert" data-testid="session-verification-error">Could not verify your session. Please try again.</p>
      <Button onClick={onRetry} data-testid="session-verification-retry">Retry</Button>
    </> : <p role="status" className="text-sm text-gray-600" data-testid="session-verifying">Verifying session…</p>}
  </div>
);